export default `---
slug: portugal
country: Portugal
countryCode: PRT
continent: Europe
year: 2021
title: "Portugal"
description: "Lisbon, Porto, and the Atlantic coast — pastel de nata and fado."
thumbnail: /images/travels/PRT/portugal_thumb.jpg
relatedLinks: []
---
![portugal](/images/travels/PRT/portugal_thumb.jpg)

*Story coming soon — stay tuned!*

I visited Portugal and it was an incredible experience. Full story and photos are being written up and will appear here soon.
`;
